module.exports = __webpack_public_path__ + "static/media/C032.6b3ffcb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C032.jpg
// module id = 315
// module chunks = 0